import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { FieldSelectMultiple } from './FieldSelectMultiple';
import { FieldSelectSingle } from './FieldSelectSingle';
import { isFieldSelectMultipleProps, isFieldSelectSingleProps } from './utils';
export const FieldSelect = forwardRef((props, ref) => {
    if (isFieldSelectMultipleProps(props)) {
        return _jsx(FieldSelectMultiple, Object.assign({}, props, { ref: ref }));
    }
    if (isFieldSelectSingleProps(props)) {
        return _jsx(FieldSelectSingle, Object.assign({}, props, { ref: ref }));
    }
    return null;
});
